<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapter-number---IVP" title="Cover"><span epub:type="pagebreak" id="pageii" title="ii"></span></h1>
<div class="Basic-Text-Frame">
<div class="photo50"><img alt="Single, Gay, Christian Title Page" class="img100" src="Images/SGCtp.png"/></div>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.IVPress.com/books" target="_blank"><img alt="IVP Books Imprint" src="Images/IVPBooks.png"/></a></p>
</div>
<h1 class="chapter-number---IVP sigil_not_in_toc"><span epub:type="pagebreak" id="pageiii" title="iii"></span></h1>
<div>
<div class="Basic-Text-Frame" id="_idContainer000">
<h1 class="title-page-title" id="sigil_toc_id_1" title="Title Page"></h1>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_titlepage.vue?59fa96c5